import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environments/environment';

export interface FooterLink {
  label: string;
  url: string;
}

export interface BrandingConfig {
  companyName: string;
  productName: string;
  pageTitle: string;
  logo: string;
  favicon: string;
  colors: {
    primary: string;
    gold: string;
  };
  footer: {
    copyrightHolder: string;
    copyrightUrl: string;
    vatNumber: string;
    links: FooterLink[];
  };
  loginMessage: string;
}

@Injectable({ providedIn: 'root' })
export class BrandingService {
  readonly branding: BrandingConfig = environment.branding;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.applyBranding();
  }

  private applyBranding(): void {
    const root = this.document.documentElement;
    const { colors } = this.branding;

    root.style.setProperty('--brand-primary', colors.primary);
    root.style.setProperty('--brand-gold', colors.gold);

    // Set favicon
    const favicon = this.document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = this.branding.favicon;
    }
  }
}
